import { createContext, useContext } from 'react';
import { ProductCarouselAll } from '@msc-b2c/interfaces/types';

export const ProductCarouselContext = createContext<undefined | ProductCarouselAll>(undefined);

//consume context, return error if component not nested in provider
export function useProductCarouselContext() {
  const prdctCarousel = useContext(ProductCarouselContext);

  if (prdctCarousel === undefined) {
    throw new Error('useItineraryCardContext must be used with a ItineraryCardContext');
  }

  return prdctCarousel;
}
